module.exports = __webpack_public_path__ + "img/more-options.f99ee162.svg";